import { downloadFile } from "@/utils/file"

export const getAvailability = (exhibitionSlug) => {
  return new Promise(async (resolve, reject) => {
    await axios.get('/api/shop/' + exhibitionSlug + '/availability')
      .then(response => {
        resolve(response.data)
      })
      .catch(_error => {
        reject(false)
      })
  })
}

export const getDocuments = (exhibitionSlug) => {
  return new Promise(async (resolve, reject) => {
    await axios.get('/api/shop/' + exhibitionSlug + '/documents')
      .then(response => {
        resolve(response.data)
      })
      .catch(_error => {
        reject(false)
      })
  })
}

export const getExhibitionInformation = (exhibitionSlug) => {
  return new Promise(async (resolve, reject) => {
    await axios.get('/' + exhibitionSlug + '/api')
      .then(response => {
        resolve(response.data)
      })
      .catch(_error => {
        reject(false)
      })
  })
}

export const downloadExternalPrintingInformation = async (document, inEnglish = false) => {
  await downloadFile(
    '/api/external/printing-information/' + document.identifier + '/download',
    ((inEnglish) ? document.name_en : document.name) + '.' + document.extension
  )
}

export const downloadExternalPrintCloudUpload = async (upload, externalPrintCloudUuid) => {
  await downloadFile(
    '/api/external/print/' + externalPrintCloudUuid + '/upload/' + upload.id,
    upload.original_name
  )
}

export const downloadInternalPrintingInformation = async (document, inEnglish = false) => {
  await downloadFile(
    '/api/internal/printing-information/' + document.identifier + '/download',
    ((inEnglish) ? document.name_en : document.name) + '.' + document.extension
  )
}

export const downloadInternalPrintCloudUpload = async (upload, internalPrintCloudUuid) => {
  await downloadFile(
    '/api/internal/print/' + internalPrintCloudUuid + '/upload/' + upload.id,
    upload.original_name
  )
}